export default "__VITE_ASSET__BTh7vC45__"